import type { TTripTaskRes } from 'api/swagger';
import { ETripTaskStatus } from 'types/trip-task-status';
import { ETripTaskType } from 'types/trips';

export const getMergeTasks = (task: TTripTaskRes, tripTasks: TTripTaskRes[]): TTripTaskRes[] => {
  const isWarehouseTask = task.type === ETripTaskType.loading_wh || task.type === ETripTaskType.unloading_wh;

  if (task.status === ETripTaskStatus.done || !isWarehouseTask) return [];

  return tripTasks.filter(
    (candidate) =>
      candidate.status !== ETripTaskStatus.done &&
      candidate.type === task.type &&
      candidate.warehouseId === task.warehouseId,
  );
};
